import { useEffect } from 'react';
import { VERTICAL_NAV_RENDERED } from '../../../constants/metrics';
import { getNavStartTime } from '../../../utils/navStartTime';
import { Metrics } from '../../../utils/metrics';
import usePrevious from '../../../hooks/usePrevious';
import useNavItems from '../../../hooks/useNavItems';
import useUsageTracker from '../../../hooks/useUsageTracker';
import useIsVerticalNavPinned from '../../../hooks/useIsVerticalNavPinned';
import { clearNavInteractionStartTime, setNavInteractionStartTime } from '../../../utils/navInteractionStartTime';
const useVerticalNavTracking = ({
  isInteractingWithVerticalNav
}) => {
  const {
    openMenus: {
      primary
    },
    primaryNav: {
      openTooltip
    }
  } = useNavItems();
  const isVerticalNavPinned = useIsVerticalNavPinned();
  const {
    track
  } = useUsageTracker();
  const isInteractingWithMenuItems = !!(primary || openTooltip);
  const wasInteractingWithMenuItems = usePrevious(isInteractingWithMenuItems);
  useEffect(() => {
    clearNavInteractionStartTime();
  }, []);
  useEffect(() => {
    if (isVerticalNavPinned) {
      return;
    }
    if (isInteractingWithMenuItems && !wasInteractingWithMenuItems) {
      setNavInteractionStartTime();
      return;
    }
    if (!isInteractingWithMenuItems && !isInteractingWithVerticalNav) {
      clearNavInteractionStartTime();
    }
  }, [isInteractingWithMenuItems, isInteractingWithVerticalNav, isVerticalNavPinned, track, wasInteractingWithMenuItems]);
  useEffect(() => {
    const navStartTime = getNavStartTime();
    if (navStartTime) {
      Metrics.timer(VERTICAL_NAV_RENDERED).update(performance.now() - navStartTime);
    }
  }, []);
};
export default useVerticalNavTracking;